import React, { useEffect, useState } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import api from '../../utils/api';

export const useEtapasProyecto = (proyectoId, unidadCodigo) => {
  const [info, setInfo] = useState({ etapas: [], sugerida_id: null, cargando: false });
  useEffect(() => {
    if (!proyectoId) { setInfo({ etapas: [], sugerida_id: null, cargando: false }); return undefined; }
    let vigente = true;
    setInfo(prev => ({ ...prev, cargando: true }));
    const t = setTimeout(() => {
      api.get('/entregas/config/etapas-proyecto', { params: { proyecto_id: proyectoId, unidad_codigo: unidadCodigo || undefined } })
        .then(r => vigente && setInfo({ ...r.data, cargando: false }))
        .catch(() => vigente && setInfo({ etapas: [], sugerida_id: null, cargando: false }));
    }, 350);
    return () => { vigente = false; clearTimeout(t); };
  }, [proyectoId, unidadCodigo]);
  return info;
};

export const EtapaSelect = ({ etapas, value, onChange, testId = 'select-etapa', className = '' }) => (
  <Select value={value || ''} onValueChange={id => onChange(etapas.find(e => e.id === id))}>
    <SelectTrigger className={className} data-testid={testId}>
      <SelectValue placeholder="Seleccionar etapa" />
    </SelectTrigger>
    <SelectContent>
      {etapas.map(e => (
        <SelectItem key={e.id} value={e.id} data-testid={`${testId}-opcion-${e.codigo || e.id}`}>{e.nombre}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);
